import { getLocalUserInfo, getToken, removeToken, setToken } from '@/utils/token'
import { VIP_LEVEL } from '@/config'
import { userLogin } from '@/api'
import { uploadLoginData } from '@/utils/baiduOCPC'
import { Message } from 'element-ui'

export default {
  namespaced: true,
  state: () => ({
    userInfo: getLocalUserInfo() || null // 存放用户信息
  }),
  getters: {
    user: state => {
      return state.userInfo?.money_info
    },
    isNonVIP: state => {
      return state.userInfo?.money_info?.vip === VIP_LEVEL.NON_VIP
    },
    isCountVIP: state => {
      return state.userInfo?.money_info?.vip === VIP_LEVEL.COUNT_VIP
    },
    isTimeVIP: state => {
      return state.userInfo?.money_info?.vip === VIP_LEVEL.TIME_VIP
    },
    isPermanentVIP: state => {
      return state.userInfo?.money_info?.vip === VIP_LEVEL.PERMANENT_VIP
    },
    isVIP: state => {
      return state.userInfo?.money_info?.vip !== VIP_LEVEL.NON_VIP
    },
    isLogin: state => {
      return state.userInfo !== null || !!getToken()
    }
  },
  mutations: {
    updateUserInfo: (state, userInfo) => {
      state.userInfo = userInfo
    },
    logout(state) {
      state.userInfo = null
      removeToken()
    }
  },
  actions: {
    setUserInfo: ({ commit }, payload) => {
      commit('updateUserInfo', payload)
    },
    async login({ commit }, payload) {
      let { code } = payload
      if (!getToken() && code) {
        let res = await userLogin(code)
        if (res.data.status === 0) {
          setToken(res.data.data)
          await commit('setUserInfo', res.data.data)
          await uploadLoginData().catch(e => {})
          Message({
            type: 'success',
            message: '登录成功'
          })
        }
      }
    },
    logout({ commit }) {
      commit('logout')
    },
    checkAllowDownload: ({ getters }, downloads) => {
      // 用户必须登录，还得是VIP
      if (getters.isLogin && getters.isVIP) {
        // 如果是次数VIP，则判断当前下载次数是否够下载
        if (getters.isCountVIP) {
          return getters.user.has_image_count > downloads
        }
        return true
      }
      return false
    }
  }
}
